<template>
  <toolbar-button
    id="pw-comparison-toolbar-button"
    :to="{ name: 'ProductComparison' }"
    :aria-label="$t('openProductComparison')"
    @click="track"
  >
    <toolbar-badge :content="count" :icon="mdiSwapHorizontalBold" />
  </toolbar-button>
</template>

<script setup lang="ts">
import ToolbarBadge from '@/components/toolbar/ToolbarBadge.vue'
import ToolbarButton from '@/components/toolbar/ToolbarButton.vue'
import useProductComparison from '@/modules/product/useProductComparison'
import ApplicationHeaderEvent from '@/modules/tracking/events/applicationHeader'
import { trackEvent } from '@/modules/tracking/useTracking'
import { mdiSwapHorizontalBold } from '@mdi/js'
import { storeToRefs } from 'pinia'

const { count } = storeToRefs(useProductComparison())
const track = () => trackEvent(ApplicationHeaderEvent.ProductComparison)
</script>
